import { MouseEvent, useMemo } from 'react';

import { t } from '@lingui/macro';

import Loading from '@decisiv/ui-components/lib/components/Loading';
import Wizard from '@decisiv/ui-components/lib/components/Wizard';

import BulkCreateContactsProvider, {
  useBulkCreateContactsContext,
} from './context/BulkCreateContactsContext';
import StepOne from './StepOne';
import Summary from './Summary';

export interface BulkCreateContactsModalProps {
  onCancel: (event: MouseEvent<unknown> | KeyboardEvent) => void;
}

function BulkCreateContactsModal() {
  const { stepOneProps, wizardProps } = useBulkCreateContactsContext();

  const steps = useMemo(
    () => [
      {
        title: t`Upload`,
        content: <StepOne />,
        hideBodyTitle: true,
        intermediateContent: (
          <Loading
            size="small"
            title={t`Creating Contact(s)...`}
            description={t`Your Contacts are being processed. Closing this window won't interrupt it. Results will be available when complete.`}
          />
        ),
        ...stepOneProps,
      },
      {
        title: t`Summary`,
        content: <Summary />,
        hideBodyTitle: true,
      },
    ],
    [stepOneProps],
  );

  return (
    <Wizard
      visible
      title={t`Bulk Add Contacts`}
      steps={steps}
      {...wizardProps}
    />
  );
}

export default function BulkCreateContactsModalWrapper(
  props: BulkCreateContactsModalProps,
) {
  return (
    <BulkCreateContactsProvider onClose={props.onCancel}>
      <BulkCreateContactsModal />
    </BulkCreateContactsProvider>
  );
}
